// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"94a46293","732":"47853329"}[chunkId] + ".chunk.js";
};